import React from 'react';
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import bgRed from "../assets/images/bg-red.png"
import close from "../assets/images/close.png"
import success from "../assets/images/success.png"
import newService from "../assets/images/new-service.png"
import creditCard from "../assets/images/credit-card.png"
import accSetup from "../assets/images/account-setup.png"

// import ApiService from "../services/ApiService";
// import AuthService from "../services/AuthService";


const Notifications = () => {
  return (
    <div className="main-heading loyality-points">
      <div className="top-bar d-flex justify-content-between px-4 pt-5 pb-3">
        <div className="top-bar-left d-flex">
          <span>
            <Link to={"/Promotions"}>
              <MdOutlineKeyboardArrowLeft className="chevron-left-itemsDetails shadow" />
            </Link>
          </span>
          <p className="fs-4">Notifications</p>
        </div>
      </div>
      <div className="notifications">
        <div className="order-cancelled">
          <div className="icon">
            <img src={close} alt="cancel icon" />
          </div>
          <div className="text-content">
            <div className="header">
              <h4>Orders Cancelled!</h4>
              <span className="new-badge">New</span>
            </div>
            <p className="date">19 Dec, 2022 | 20:50 PM</p>
            <p className="description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudan.
            </p>
          </div>
        </div>

        <div className="order-successful">
          <div className="icon">
            <img src={success} alt="cancel icon" />
          </div>
          <div className="text-content">
            <div className="header">
              <h4>Orders Successful!</h4>
              <span className="new-badge">New</span>
            </div>
            <p className="date">19 Dec, 2022 | 20:50 PM</p>
            <p className="description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudan.
            </p>
          </div>
        </div>

        <div className="newService">
          <div className="icon">
            <img src={newService} alt="cancel icon" />
          </div>
          <div className="text-content">
            <div className="header">
              <h4>New service Available</h4>
            </div>
            <p className="date">19 Dec, 2022 | 20:50 PM</p>
            <p className="description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudan.
            </p>
          </div>
        </div>

        <div className="creditCard">
          <div className="icon">
            <img src={creditCard} alt="cancel icon" />
          </div>
          <div className="text-content">
            <div className="header">
              <h4>Credit Card Connected </h4>
            </div>
            <p className="date">19 Dec, 2022 | 20:50 PM</p>
            <p className="description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudan.
            </p>
          </div>
        </div>

        <div className="accSetup">
          <div className="icon">
            <img src={accSetup} alt="cancel icon" />
          </div>
          <div className="text-content">
            <div className="header">
              <h4>Account Setup Successful!</h4>
            </div>
            <p className="date">19 Dec, 2022 | 20:50 PM</p>
            <p className="description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudan.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notifications;
